import { Component } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'ngd-components-promo',
    template: `
    <h2>{{ title | translate }}</h2>
    <p>{{ description | translate}}</p>
  `,
    styleUrls: ['./components-promo.component.scss'],
    standalone: true,
    imports: [TranslateModule]
})
export class NgdComponentsPromoComponent {
  title = 'hhPlatform.home.promo.title';
  description = 'hhPlatform.home.promo.description';

   constructor(public translate: TranslateService) {}
}
